// Cliente del proxy MS-Management -> MS-API-Lab para el dashboard.
import AxiosService from 'plugins/TS-lib-utils-public/services/AxiosService';

class LabStatsService extends AxiosService {
  constructor() {
    super('management');
  }

  getCurrentStats = async ({ cancelToken = null } = {}) => {
    return await this.get('/lab/stats', {
      headers: { Authorization: `Bearer ${this.getToken()}` },
      cancelToken,
    });
  };

  getStatsHistory = async (duration = '7d', interval = '1h', { cancelToken = null } = {}) => {
    return await this.get(
      `/lab/stats/history?duration=${duration}&interval=${interval}`,
      {
        headers: { Authorization: `Bearer ${this.getToken()}` },
        cancelToken,
      }
    );
  };

  getHistoriesStats = async ({ cancelToken = null } = {}) => {
    return await this.get('/lab/histories/stats', {
      headers: { Authorization: `Bearer ${this.getToken()}` },
      cancelToken,
    });
  };
}

export default new LabStatsService();
